import React from 'react'

import Icon from 'components/icon/icon.component'
import Message from 'components/message/message.component'

import useStyles from './messages-container.style'

const MessagesContainer = (props) => {
  const classes = useStyles(props)

  return (
    <div className={classes.container}>
      <Message />
      <div className={classes.logoContainer}>
        <Icon type='logo-powered' />
      </div>
    </div>
  )
}

export default MessagesContainer
